import { render, staticRenderFns } from "./react-table.vue?vue&type=template&id=72884c89&scoped=true&"
import script from "./react-table.vue?vue&type=script&lang=js&"
export * from "./react-table.vue?vue&type=script&lang=js&"
import style0 from "./react-table.vue?vue&type=style&index=0&id=72884c89&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72884c89",
  null
  
)

export default component.exports